export default __webpack_public_path__ + "static/media/Group1497@2x.ad00852b.png";